import { Skeleton } from '../../../../components'

export function OperationFormLoading () {
  return (
    <div className="flex flex-col gap-1.5">
      <Skeleton className="h-4 w-24"/>
      <Skeleton className="h-8 w-full"/>
    </div>
  )
}
